import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { confirmPickupApi } from './confirmPickup.api'
import confirmPickupInitialState from './confirmPickup.initialState'
import { ConfirmPickupErrorResponse, ConfirmPickupRequestPayload } from './confirmPickup.types'

export const confirmPickup = createAsyncThunk(
  urls.logisticsPartner.confirmPickup,
  async (payload: ConfirmPickupRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload || {}

    try {
      const response = await confirmPickupApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      const apiError = error as ApiErrorResponse & { rateLimitCountdown?: number }

      // Extract rate limit countdown from error if present
      if (apiError.status === 429 && 'data' in apiError && apiError.data) {
        const errorData = apiError.data as { rateLimitCountdown?: number }
        apiError.rateLimitCountdown = errorData.rateLimitCountdown
      }

      errorHandler.handleApiError(apiError)

      return rejectWithValue(apiError as ConfirmPickupErrorResponse)
    }
  }
)

const confirmPickupSlice = createSlice({
  name: urls.logisticsPartner.confirmPickup,
  initialState: confirmPickupInitialState,
  reducers: {
    resetConfirmPickup: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmPickup.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(confirmPickup.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(confirmPickup.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ConfirmPickupErrorResponse
        state.success = null
      })
  }
})

export const { actions: confirmPickupActions, reducer: confirmPickupReducer } = confirmPickupSlice
export const { resetConfirmPickup } = confirmPickupActions
export default confirmPickupSlice.reducer
